// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quotation-client-search input.el-input__inner {\n  width: 100% !important;\n}\n.quotation-client-search .el-row {\n  margin-right: 5px !important;\n}\n", ""]);
// Exports
module.exports = exports;
